import m from "moment";

const moment = m;

export const formatDefaultDate = (date, format = "DD-MM-YYYY") => {
    return moment(date).format(format); //25/03/1
}

export default moment